<template>
	<header class="header main br-b-1">
		<button type="button" class="btn-menu" v-on:click="openSideMenu">
			<font-awesome-icon icon="bars" class="color-white" />
		</button>
		<div class="h-20 color-black text-right name-box">
			<span class="pt-2 pb-2 pos-relative-vertical font-bold text-size-l ">{{ loginMember && loginMemberNm }}님</span>
			<span class="pt-2 pb-2 pos-relative-vertical font-bold text-size-l ml-2 mr-2 ">|</span>
			<nav-link class="pt-2 pb-2 pos-relative-vertical font-bold text-size-l" :click="doLogout">로그아웃</nav-link>
		</div>
	</header>
</template>

<script>
import eventBus from '@/plugins/event-bus';
import CONST from '@/constants';

export default {
	name: 'AppHeaderMain',
	data: function() {
		return {
			loginMember: null,
			loginMemberNm: '',
		};
	},
	created() {
		eventBus.$on(
			CONST.EVENTS.LOGIN_COMPLETE,
			function() {
				this.loadMemberInfo();
			}.bind(this),
		);
		eventBus.$on(
			CONST.EVENTS.LOGOUT_COMPLETE,
			function() {
				this.loadMemberInfo();
			}.bind(this),
		);
	},
	mounted() {
		this.loadMemberInfo();
	},
	computed: {
		isCompany() {
			return this.loginMember && this.loginMember.budsUserType === CONST.USER_TYPE.COMPANY;
		},
	},
	methods: {
		loadMemberInfo: function() {
			try {
				let dt = this.$device.loadLocalData('LOGIN_USER');
				if (dt) {
					this.loginMember = JSON.parse(dt);
					this.loginMemberNm = this.loginMember.userNmKor;
					if (this.isCompany) {
						this.loginMemberNm = this.loginMember.companyNmKor;
					}
				} else {
					this.loginMember = null;
				}
			} catch (e) {
				console.error(e);
			}
		},
		goCart: function() {
			this.$device.pushView('/cart');
		},
		goMypage: function() {
			//this.$device.openRightMyMenu();
			if (this.loginMember) {
				this.$device.openRightMyMenu();
				return;
			}
			this.$device.openRightMenu();
		},
		openSideMenu: function() {
			//this.$device.pushView('/common/AppSideLeft');
			this.$device.openSideMenu();
		},
		doLogout: function() {
			this.$device.removeLocalData('LOGIN_TOKEN');
			this.$device.removeLocalData('LOGIN_USER');
			this.$device.sendEvent(CONST.EVENTS.LOGOUT_COMPLETE);
			this.$device.pushView('/login');
		},
	},
};
</script>

<style scoped></style>
